/*
 * @Author: Gary
 * @Date: 2017-12-18 16:36:09
 * @Last Modified by: yuxiaojing
 * @Last Modified time: 2018-02-22 14:25:20
 * 全局常量
 */

/* 正则 */
const validate = {
  realName: /^[\u4e00-\u9fa5_a-zA-Z0-9]{2,10}$/,
  username: /^[a-zA-Z0-9_-]{4,16}$/,
  password: /^[a-zA-Z0-9_-]{6,12}$/,
  verifyCode: /^[0-9_-]{4}$/,
  phone: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|(147))\d{8}$/,
  money: /(^[1-9]\d*((.[1-9]{1,2})|(.0[1-9]))?$)|(^0((.[1-9]{1,2})|(.0[1-9]))?$)/,
  email: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,4})$/,
  idCard: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  chinese: /[\u4E00-\u9FA5]/,
  carCard: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
}

/* 七牛配置 需要在根目录下的index.html 引入七牛js-sdk */
const qiniu = {
  url: 'https://upload-z1.qiniup.com',
  baseUrl: 'https://upload-z1.qiniup.com/putb64/-1',
  link: 'http://vod.yueya.shixing.me/',
  token: 'SmewdXtHoTBP3OsX5Pz1JcxATbV-tooyEl4U1qFD:ByM3u43520BFBGzQLB0gqeUW9uA=:eyJzY29wZSI6Inl1ZXlhcGljIiwiZGVhZGxpbmUiOjI3NzUxNjgwMDB9'
}

export default {
  validate, qiniu
}



// WEBPACK FOOTER //
// ./src/utils/constant.js